import Auth0Lock from 'auth0-lock';
import {
  AuthService,
  TrackingEventService,
} from '@pingum/api-services';
import { removeLocalstorageUtmParameters } from '../../utils/utmHelper';

import { dispatch } from '../../redux/store';
import {
  loginSuccess,
  loginError,
} from '../../redux/auth/actions';
import { getMe } from '../../redux/user/actions';
import { getQueryParam } from '../../utils/urlHelper';
import config from './config';

let lock;

export default class Auth0LockService {
  static authenticated({
    idToken,
    accessToken,
    isLoginRequest = true,
  }) {
    AuthService.setToken(idToken);
    AuthService.setAccessToken(accessToken);

    if (global.window.localStorage.getItem('signup_request') === 'true') {
      TrackingEventService.postTrackingEvent({
        type: 'signup',
        utmSource: global.window.localStorage.getItem('utm_source'),
        utmMedium: global.window.localStorage.getItem('utm_medium'),
        utmCampaign: global.window.localStorage.getItem('utm_campaign'),
        utmTerm: global.window.localStorage.getItem('utm_term'),
        itmContent: global.window.localStorage.getItem('utm_content'),
      });
      removeLocalstorageUtmParameters();
    }

    dispatch(loginSuccess());
    dispatch(getMe({ isLoginRequest }));
  }

  static authorizationError(error) {
    if (error && error.errorDescription && error.errorDescription.indexOf('verify') >= 0) {
      global.window.localStorage.setItem('signup_request', 'true');
    }
    dispatch(loginError({ error }));
  }

  static login() {
    if (getQueryParam('tenant')) {
      global.window.localStorage.setItem('redirectTenant', getQueryParam('tenant'));
    }
    if (getQueryParam('redirect')) {
      global.window.localStorage.setItem('redirect', getQueryParam('redirect'));
    }
    Auth0LockService.getLock().show({ initialScreen: 'login' });
  }

  static signup() {
    Auth0LockService.getLock().show({ initialScreen: 'signUp' });
  }

  static logout() {
    window.localStorage.removeItem('id_token');
    window.localStorage.removeItem('access_token');
    window.localStorage.removeItem('profile');
    window.localStorage.removeItem('profile_expiration');
    window.localStorage.removeItem('tenant');
    window.localStorage.removeItem('redirect');
    window.localStorage.removeItem('redirectTenant');
  }

  static getLock() {
    if (!lock) {
      lock = new Auth0Lock(config.AUTH0_CLIENT_ID, config.AUTH0_DOMAIN, config);
      lock.on('authenticated', Auth0LockService.authenticated);
      lock.on('authorization_error', Auth0LockService.authorizationError);
    }
    return lock;
  }
}
